<template>
	<div class="patient_result bg-white">
		<div v-if="$route.query.type === 'apply'">
			<base-result
				v-if="info.approveStatus == 0"
				:text="`已向${ getNickName }申请共管，请等待对方通过`"
				type="wait"
			/>
			<base-result v-if="info.approveStatus == 1" :text="`您的共管申请已通过`" type="success">
				<van-button type="primary" block @click="$router.push('/')">进入卒中平台</van-button>
			</base-result>
			<base-result v-if="info.approveStatus == 2" :text="`您的共管申请被拒绝`" type="error" />
		</div>
		<div v-if="$route.query.type === 'invite'">
			<base-result
				v-if="info.approveStatus == 1"
				:text="`已通过${ info.applyNickname }的共管申请`"
				type="success"
			>
				<van-button type="primary" block @click="$router.push('/')">进入卒中平台</van-button>
			</base-result>
			<base-result v-if="info.approveStatus == 2" :text="`已拒绝${ info.applyNickname }的共管申请`" type="error">
				<van-button type="primary" block @click="$router.push(`/jointManage/list`)">再次邀请</van-button>
				<van-button block class="mt-28" @click="$router.push('/')">进入卒中平台</van-button>
			</base-result>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'patient-result',
		data: () => ({
			loading: false,
			info: {}
		}),
		created () {
			this.getAuditStatus()
		},
		computed: {
			getNickName () {
				if (this.info.nickname) return this.info.nickname
				if (this.info.auditAccountPhone) return this.info.auditAccountPhone
				return '--'
			},
		},
		methods: {
			getAuditStatus () {
				this.loading = true
				this.$api.patient.geApplyStatusByApplyId(this.$route.params.id).then(res => {
					this.loading = false
					if (!res.code) {
						this.info = res.data
					}
				}).catch(() => this.loading = false)
			}
		}
	};
</script>

<style scoped lang="less">
	.patient_result {
		min-height: 100vh;
		padding: 0 40px;
	}
</style>
